module.exports = __webpack_public_path__ + "img/inbox-announcement-reject.8f2cc39f.svg";